$( document ).ready(function() {
  $('[data-open-gentle-diamonds-video-modal]').click(function (e) {
      $(`.mod-Modal[data-modal=${$(this).data('modal')}]`).addClass(
        'mod-Modal-open'
      )

      let videoURL = $('.mod-Video').prop('src')
      videoURL += '&autoplay=1'
      $('.mod-Video').prop('src', videoURL)

    //  $('body').addClass('no-scroll')
      event.preventDefault()
    })

    // Close Modal
    $('[data-close-gentle-diamonds-video-modal]').click(function () {
      $('.mod-Modal').removeClass('mod-Modal-open')
      $('body').removeClass('no-scroll')

      let videoURL = $('.mod-Video').prop('src')
      videoURL = videoURL.replace('&autoplay=1', '')
      $('.mod-Video').prop('src', '')
      $('.mod-Video').prop('src', videoURL)

      event.preventDefault()
    })   
    
    // Click outside of modal to close
    $(document).on('touchend click', function(e) {

      $('.mod-Modal-video').click(function(event) {
        var $target = $(event.target);

        if ($target.parents('.par-FullWidth').length == 0) {
          

          let videoURL = $('.mod-Video').prop('src')
          if(videoURL){
            $('.mod-Modal').removeClass('mod-Modal-open')
          videoURL = videoURL.replace('&autoplay=1', '')
          $('.mod-Video').prop('src', '')
          $('.mod-Video').prop('src', videoURL)

          $('body').removeClass('no-scroll')
          }
        }
      });

    })
  
  	$('a[href="#2"]').click(function(e){
      window.history.replaceState( null , null, ' ' );
    });
  
});

// window.addEventListener("resize", function() {

//   setTimeout(function () {
//     fullpage_api.reBuild();
//     console.log("resize fired");
//   }, 500)

// });

